import { LoaderFunctionArgs } from "react-router-dom";
import { getPresentationDetailsService } from "services/presentation.service";
import { getConnectionId } from "utils/localStorageServices";

function isExpired(expiry: string | null | undefined) {
  if (!expiry) return false;

  const expiryTime = new Date(expiry).getTime();
  if (Number.isNaN(expiryTime)) return false;

  return expiryTime <= Date.now();
}

export async function sharedBriefcaseGuardLoader({
  params,
}: LoaderFunctionArgs) {
  const presentationId = params.presentationId;

  if (!presentationId) {
    throw new Response("The shared briefcase link is invalid.", {
      status: 404,
    });
  }

  try {
    const connectionId = getConnectionId();

    const response = await getPresentationDetailsService({ presentationId, connectionId });
    const presentation = response?.presentation;

    if (!presentation?.id) {
      throw new Response("The shared briefcase link is invalid.", {
        status: 404,
      });
    }

    if (isExpired(presentation.expiry)) {
      throw new Response("This shared briefcase link has expired.", {
        status: 404,
      });
    }

    return null;
  } catch (error) {
    if (error instanceof Response) {
      throw error;
    }

    throw new Response("The shared briefcase link is invalid.", {
      status: 404,
    });
  }
}
